"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsaturationsObject = void 0;
exports.unsaturationsObject = {
    O: 0,
    N: 1,
    H: -1,
    Na: -1,
    K: -1,
    Li: -1,
    Ca: -2,
    C: 2,
    F: -1,
    Si: 2,
    Cl: -1,
    Br: -1,
    I: -1,
    S: 0,
    P: 1,
};
//# sourceMappingURL=unsaturationsObject.js.map